<template>
  <!-- exhibition-product .ep -->
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>管理</BreadcrumbItem> 
          <BreadcrumbItem to="/host/index/ex/list">
            展商列表
          </BreadcrumbItem>
          <BreadcrumbItem>
            <span v-if="company && company.name">{{company.name}}</span> 
          </BreadcrumbItem>
          <BreadcrumbItem>展品</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title" v-if="String(showTabs) === '1'">展品</div>
        <!-- <p class="header-tool-text" v-if="String(showTabs) === '1'">共发布 {{num || 0}} 个展品</p>  --> 
        <Input
          search
          placeholder="请输入关键字"
          v-model="searchField"
          @on-search="searchPro()"
          v-if="String(showTabs) === '1'"
          style="width:230px;margin-top:20px;"
        />
      </div> 
      <div v-show="String(showTabs) === '1'" class="header-tool-box">
        <div class="htb-item" @click="$router.push(`/host/index/ex/pro-add?compId=${editId}`)">
          <span class="htb-add">+</span>
          <span>添加展品</span>
        </div>
      </div>
    </div>
    <exhibitionProductItem
      ref="exhibitionProductItem"
      v-if="String(showTabs) === '1'"
      :searchField="searchField"
      :compId="editId"
    />
  </div>
</template>

<script>
import exhibitionProductItem from "./subpages/exhibition-product-item/exhibition-product-item.vue";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "exhibition-business",
  data() {
    return {
      company: null,
      editId: "",
      addBrandflag: false,
      showTabs: "1",
      searchField: "" // 搜索关键字
    };
  },
  components: {
    exhibitionProductItem
  },
  async created() {
    let query = this.$route.query;
    if (query && query.id) {
      this.editId = query.id;
      let proData = await this.getCompanyByJoin(this.option);
      if (proData) {
        proData.items.map(c => {
          if (c.categories) {
            c.categories = JSON.parse(c.categories);
          } else {
            c.categories = [];
          }
          if (c.boothInfo) {
            c.boothInfo = JSON.parse(c.boothInfo);
          } else {
            c.boothInfo = [];
          }
        });
        this.company = proData.items[0];
        console.log(this.company);
      }
    }
    this.changeTab();
  },
  computed: {
    ...mapGetters({
      list: "productModule/list",
      pageInfo: "productModule/pageInfo",
      current: "productModule/current"
    }),
    query() {
      return this.$route.query;
    },
    option() {
      return {
        ExhibitionId: this.exhibitionInfo.id,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "compId",
                  Value: `%${this.editId}%`
                }
              }
            ]
          }
        }
      };
    },
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  methods: {
    ...mapMutations({
      refushPageInfo: "productModule/refushPageInfo",
      refushWheres: "productModule/refushWheres",
      refushCurrent: "productModule/refushCurrent"
    }),
    ...mapActions({
      getCompanyByJoin: "hostSetModule/getCompanyByJoin",
      getList: "productModule/getList",
      addProduct: "productModule/addProduct",
      add: "productModule/add",
      edit: "productModule/edit",
      getOne: "productModule/getOne",
      remove: "productModule/remove"
    }),
    searchPro() {
      this.$refs.exhibitionProductItem.init();
    },
    changeTab() {
      if (this.query && this.query.type && this.query.type === "all") {
        this.showTabs = "1";
      }
    },
    switchBrand(name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?taype=all`);
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=mes`);
      } else if (name === "3") {
        this.$router.push(`${this.$route.path}?type=apply`);
      }
    },
    downloadList() {
      this.$refs.exhibitionProductApply.exportInfo();
    }
  }
};
</script>

<style scoped lang="scss">
.eb-top-r {
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 15px;
  &-box {
    width: 148px;
    height: 78px;
    border: 1px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.5s;
    &:hover {
      border: 1px dashed #1890ff;
      transition: 0.5s;
    }
    .I1 {
      font-size: 16px;
      font-weight: bold;
      color: #1890ff;
    }
    .s3 {
      font-size: 14px;
      color: #1890ff;
      margin-left: 9px;
    }
  }
}
</style>
